import { EnvironmentProviders } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';

/**
 * App-level Highcharts setup for `highcharts-angular` 5 (`<highcharts-chart>` has no `[Highcharts]` input any more).
 *
 * - Loads the same `highcharts` module instance that the code imports statically (`import * as Highcharts from 'highcharts'`),
 *   so `Highcharts.setOptions()` / `getOptions()` / `dateFormat()` keep applying to the rendered charts.
 */
export function provideIotHighcharts(): EnvironmentProviders {
  return provideHighcharts({
    // 1. Resolve core instance safely
    instance: () => import('highcharts').then((m) => m.default ?? m),

    // 2. Extensions — highcharts-angular runs them in PARALLEL (Promise.allSettled), after the core instance is loaded.
    //    Dependent modules must be chained: `export-data` @requires `exporting` (else "reading 'prototype'" of undefined).
    modules: () => [
      import('highcharts/modules/drilldown'),
      import('highcharts/modules/exporting').then(() => import('highcharts/modules/export-data')),
      import('highcharts/modules/no-data-to-display')
    ]
  });
}
